import logo from '../LogoApp.png';

export const LogoApp = ({ className }: { className: string }) => {
  return <img src={logo} className={className} alt="logo app" />;
};
